export const trigger = (el, type) => {
  const e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
export const checkPermission = (
  { module, permission },
  { permission: userPermission }
) => {
  if (module == null) return true;

  if (userPermission[module]) {
    if (permission) {
      return checkModulePermission(
        { permission: userPermission },
        { module, permission }
      );
    }

    return true;
  }

  return false;
};
export const checkModulePermission = (
  { permission: userPermission },
  { module, permission }
) => {
  return userPermission[module].includes(permission);
};
